<template>
  <div class="home-view">
    <section class="welcome-block">
      <h2>欢迎来到实用工具箱</h2>
      <p>点击左侧菜单可以切换不同的内容页面。</p>
    </section>

    <section class="product-block">
      <h3 class="product-title">可视化大屏</h3>
      <p class="product-desc">
        轻量级低代码大屏设计平台，基于开源组件 ECharts、DataV、Element Plus 等构建，拖拽即可完成可视化设计。
        支持 HTTP/HTTPS 数据源与海康监控实时预览，业务驱动，让大屏设计更简洁、更落地。
      </p>
      <a
        href="https://screen.terracode.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="product-image-wrap"
        title="打开低代码可视化大屏设计平台"
      >
        <img
          class="product-image"
          src="https://api.terracode.cn/uploads/597b2941-d488-4144-9b69-8aa93caafea2_lowcodexc.png"
          alt="低代码可视化大屏平台预览"
          loading="lazy"
        />
      </a>
      <p class="product-actions">
        <a
          href="https://screen.terracode.cn/"
          target="_blank"
          rel="noopener noreferrer"
          class="product-link"
        >打开低代码可视化大屏设计平台</a>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IndexView'
}
</script>

<style scoped>
.home-view {
  background-color: #ffffff;
  padding: 2rem 2.25rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  max-width: 960px;
}

.welcome-block {
  margin-bottom: 2rem;
  padding-bottom: 1.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.welcome-block h2 {
  margin: 0 0 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.welcome-block p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #64748b;
}

.product-block {
  margin: 0;
}

.product-title {
  margin: 0 0 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.product-desc {
  margin: 0 0 1.25rem;
  font-size: 0.9375rem;
  line-height: 1.75;
  color: #475569;
}

.product-image-wrap {
  display: block;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.product-image-wrap:hover {
  border-color: #93c5fd;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
}

.product-image {
  display: block;
  width: 100%;
  height: auto;
}

.product-actions {
  margin: 1.25rem 0 0;
}

.product-link {
  display: inline-flex;
  align-items: center;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #2563eb;
  text-decoration: none;
  transition: color 0.2s ease;
}

.product-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
</style>
